// extracted by mini-css-extract-plugin
export default {"connect_btn":"Wallet_connect_btn__gUVx1","cursor":"Wallet_cursor__Taszi"};